import React from "react";
import FormInputText from "@app/component/form/input/text/FormInputText";
import FormSelect from "@app/component/form/input/select/FormSelect";
import FormInputStyleProperties from "@app/component/form/input/FormInputStyleProperties";
import {useTranslation} from "@app/component/translation/Translation";
import has from "lodash/has";
import get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import _upperCase from "lodash/upperCase";
import {useQuery} from "@tanstack/react-query";
import RefDataService from "@app/model/refdata/service/RefDataService";
import {CountryPrefixesQueryKeys} from "@app/model/refdata/service/RefDataQueryKeys";

type Props = {
    isRequired?: boolean,
    placeholder?: string,
    form?: any,
    namePrefix: string,
    label?: string,
    labelHint?: string,
    disabled?: boolean,
    className?: string,
    hideErrorMessage?: boolean
} & FormInputStyleProperties


const FormInputPhone: React.FunctionComponent<Props> = (
    {
        form,
        placeholder,
        namePrefix,
        isRequired = false,
        label,
        isLoading,
        disabled = false,
        labelHint,
        hideErrorMessage = false
    }) => {


    const prefixName = namePrefix + '.prefix';
    const numberName = namePrefix + '.number';

    const {t} = useTranslation("common.form.error");
    const hasError = !!form && (has(form.formState.errors, prefixName) || has(form.formState.errors, numberName));
    const errorMessage = hasError ? (get(form.formState.errors, prefixName + ".message") || get(form.formState.errors, numberName + ".message") || t("required")) : '';


    const query = useQuery({
        queryFn: RefDataService.findCountryPhonePrefixes,
        queryKey: CountryPrefixesQueryKeys.all
    })

    const renderField = () => {
        return <FormInputText name={numberName} form={form} isRequired={isRequired} disabled={disabled}
                              type="number"
                              isLoading={isLoading}
                              placeholder={placeholder} hideErrorMessage
                              className="input block w-full pl-[7.5rem]"/>
    }

    const renderPrefix = () => {
        return <div className="absolute inset-y-0 left-0 flex items-center">
            <label className="sr-only">
                Prefix
            </label>
            {!!query && !_isEmpty(query.data) &&
                <FormSelect name={prefixName}
                            form={form}
                            isRequired={isRequired}
                            disabled={disabled}
                            size="small"
                            optionsSize="medium"
                            isLoading={isLoading}
                            className="h-full rounded-md border-transparent bg-transparent py-1 pl-2 pr-7 ml-1 text-slate-600 focus:border-blue-500 focus:ring-blue-500 text-sm min-w-[115px]"
                            hideErrorMessage
                            defaultValue="+30"
                            options={query.data!.filter(o => !!o.abbreviation).map(o => {
                                return {
                                    label: `${_upperCase(o.abbreviation)} (${o.phoneInternationalPrefix})`,
                                    value: o.phoneInternationalPrefix,
                                    id: "" + o.id
                                }
                            })}/>}
        </div>
    }


    return <div>
        <div className='flex justify-between'>
            {!!label && <div className="label">{label}</div>}
            {!!labelHint && <span className="text-sm leading-6 text-slate-500">{labelHint}</span>}
        </div>
        <div className="relative mt-0.5 rounded-md">
            {renderPrefix()}
            {renderField()}
        </div>
        {!!errorMessage && !hideErrorMessage && <p className="help help-error">{errorMessage}</p>}
    </div>
}

export default FormInputPhone;